import { fetchAuth } from "../../../shared/api/ApiService"
import { MyError } from "../../../shared/lib/error/MyError"
import { IMyFeatureGrant, IMyFeatureGrantsResponse, IMyInfo, IMyInfoResponse } from "../model/types"

class MyService{
    async getInfo(): Promise<IMyInfo> {
        const res = await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + '/user')
        const {user}: IMyInfoResponse = await res.json()
        const featureGrants = await this.getFeatureGrants(user.id)
        const availableFeatures = featureGrants
            .filter(feature => feature.targetUserIds.length === 0)
            .map(feature => feature.featureKey)

        return {user, availableFeatures, featureGrants}
    }

    async getFeatureKeys(userId: number): Promise<string[]> {
        const featureGrants = await this.getFeatureGrants(userId)
        return featureGrants
            .filter(feature => feature.targetUserIds.length === 0)
            .map(feature => feature.featureKey)
    }

    private async getFeatureGrants(userId: number): Promise<IMyFeatureGrant[]> {
        const res = await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + `/api/v1/idm/staff/${userId}/features`)
        const {featureGrants}: IMyFeatureGrantsResponse = await res.json()

        return featureGrants
    }

    async login(email: string, password: string){
        const res = await fetch(process.env.REACT_APP_SERVER_URL + '/auth/login', {
            method: "POST",
            body: JSON.stringify({email, password})
        })
        if(!res.ok && res.status === 400){
            const text = await res.text()
            throw new MyError(text)
        }
    }

    async logout() {
        await fetchAuth(`${process.env.REACT_APP_SERVER_URL}/auth/logout`, {
            method: "POST"
        })
        localStorage.removeItem('auth_token')
    }

    async register(email: string, password: string){
        const res = await fetch(process.env.REACT_APP_SERVER_URL + '/auth/register', {
            method: "POST",
            body: JSON.stringify({email, password})
        })
        if(!res.ok && res.status === 400){
            const text = await res.text()
            throw new MyError(text)
        }
    }
    
    async loginVerify(email: string, code: string){
        const res = await fetch(process.env.REACT_APP_SERVER_URL + '/auth/login/verify', {
            method: "POST",
            body: JSON.stringify({email, code}),
            credentials: 'include'
        })
        if(!res.ok && res.status === 400){
            const text = await res.text()
            throw new MyError(text)
        }
        const {token} : {token: string} = await res.json()
        localStorage.setItem('auth_token', token)
    }

    async registerVerify(email: string, code: string){
        const res = await fetch(process.env.REACT_APP_SERVER_URL + '/auth/register/verify', {
            method: "POST",
            body: JSON.stringify({email, code}),
            credentials: 'include'
        })
        if(!res.ok && res.status === 400){
            const text = await res.text()
            throw new MyError(text)
        }
        const {token} : {token: string} = await res.json()
        localStorage.setItem('auth_token', token)
    }
}

export const myService = new MyService()
